import { render, staticRenderFns } from "./notices.vue?vue&type=template&id=1bdc98be&scoped=true&"
import script from "./notices.vue?vue&type=script&lang=js&"
export * from "./notices.vue?vue&type=script&lang=js&"
import style0 from "./notices.vue?vue&type=style&index=0&id=1bdc98be&prod&lang=scss&scoped=true&"
import style1 from "./notices.vue?vue&type=style&index=1&id=1bdc98be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdc98be",
  null
  
)

export default component.exports